<div class="d-flex flex-column min-vh-100">
  <div class="row flex-grow-1">
    <div class="col">
      <router-outlet />
    </div>
  </div>
</div>
